import React from 'react'
import ManageRelease from '../../../components/AdminRelease/ManageRelease'

const ReleasePage = () => {
    return (
        <div class="w-full">
            <ManageRelease />
        </div>
    )
}

export default ReleasePage
